<div class="container-fluid mt-3">
  <div class="row row-5">
    <div class="col-12 text-right mt-2" ref="cardBox">
      <div>
        <!-- 公開表示ボタン -->
        <b-button variant="primary" v-on:click="switchTable" v-show="!isPublished && isVisible" size="sm">
          {{ $t('message.button_vehicle_system_show_published') }}
        </b-button>
        <!-- 非公開表示ボタン -->
        <b-button variant="primary" v-on:click="switchTable" v-show="isPublished && isVisible" size="sm">
          {{ $t('message.button_vehicle_system_show_unpublished') }}
        </b-button>
      </div>
      <!-- isVisible=true→非公開が表示できる権限 -->
      <div v-if="isVisible" class="mt-2 mb-n5">
        <!-- isPublished=true/false→公開/非公開 -->
        <div v-if='isPublished'>
          <!-- 公開用ラベル -->
          <strong>{{ $t('message.label_vehicle_published') }}</strong>
        </div>
        <div v-else>
          <!-- 非公開用ラベル -->
          <strong>{{ $t('message.label_vehicle_unpublished') }}</strong>
        </div>
      </div>
      <ul class="nav nav-tabs pak-country-nav-tabs mt-3" role="tablist">
        <li v-for="tab in tabs" class="nav-item" role="presentation">
          <a v-bind:href="'#'" @click.prevent="switchCountryTab(tab.country)" role="tab"
            class="nav-link pak-country-nav-link" v-bind:class="{ 'active': tab.country === reproRegion }">
            {{ $t(tab.label) }}
          </a>
        </li>
      </ul>
      <customCard headerTitle="message.header_pak_search" :isCollapse="true" @expandHeader="cardCollapsed">
        <template v-slot:body>
          <div class="row text-left">
            <!-- Line 1 -->
            <div class="col-12">
              <div class="d-flex w-100">
                <!-- 日本 検索ボックス -->
                <div v-if="reproRegion === 'Domestic'" class="col-12 text-left mt-3">
                  <div class="d-flex w-100">
                    <!-- 書換後部番 -->
                    <div class="w-20">
                      <b-form-group class="form-group">
                        <label class="label-sm">{{ $t("message.label_sold_vehicle_search_pack_number") }}</label>
                        <b-form-input type="text" v-model="packNumber" id="pack_number" size="sm">
                          {{ packNumber }}</b-form-input>
                      </b-form-group>
                    </div>
                    <div class="w-20 ml-2">
                      <!-- 車種 検索 -->
                      <b-form-group class="form-group">
                        <label class="label-sm">{{ $t("message.label_sold_vehicle_search_vehicle") }}</label>
                        <b-form-select v-model="vehicle" size="sm" class="custom-select custom-select-sm">
                          <option v-for="item in getPullDownList('vehicle')" :value="item">{{ item }}</option>
                        </b-form-select>
                      </b-form-group>
                    </div>
                    <div class="w-20 ml-2">
                      <!-- 型式 検索 -->
                      <b-form-group class="form-group">
                        <label class="label-sm">{{ $t("message.label_sold_vehicle_search_classification") }}</label>
                        <b-form-select v-model="year" size="sm" class="custom-select custom-select-sm">
                          <option v-for="item in getPullDownList('year')" :value="item">{{ item }}</option>
                        </b-form-select>
                      </b-form-group>
                    </div>
                    <div class="w-20 ml-2">
                      <!-- 年改 検索 -->
                      <b-form-group v-if="reproRegion === 'Domestic'" class="form-group">
                        <label class="label-sm">{{ $t("message.label_sold_vehicle_search_minor_change") }}</label>
                        <b-form-select v-model="modelLine" size="sm" class="custom-select custom-select-sm">
                          <option v-for="item in getPullDownList('model_line')" :value="item"
                            v-on:change="changePullDownStatus">{{ item }}</option>
                        </b-form-select>
                      </b-form-group>
                    </div>
                    <!-- エンジン 検索 -->
                    <div class="w-20 ml-2">
                      <b-form-group class="form-group">
                        <label class="label-sm">{{ $t("message.label_sold_vehicle_search_engine") }}</label>
                        <b-form-select v-model="engine" size="sm" class="custom-select custom-select-sm">
                          <option v-for="item in getPullDownList('engine')" :value="item">{{ item }}</option>
                        </b-form-select>
                      </b-form-group>
                    </div>
                    <div class="w-20 ml-2">
                      <!-- トランスミッション 検索 -->
                      <b-form-group class="form-group">
                        <label class="label-sm">{{ $t("message.label_sold_vehicle_search_t_m") }}</label>
                        <b-form-select v-model="transmission" size="sm" class="custom-select custom-select-sm">
                          <option v-for="item in getPullDownList('transmission')" :value="item">{{ item }}</option>
                        </b-form-select>
                      </b-form-group>
                    </div>
                    <div class="w-20 ml-2">
                      <!-- その他 検索 -->
                      <b-form-group class="form-group">
                        <label class="label-sm">{{ $t("message.label_sold_vehicle_search_other") }}</label>
                        <b-form-select v-model="other" size="sm" class="custom-select custom-select-sm">
                          <option v-for="item in getPullDownList('other')" :value="item">{{ item }}</option>
                        </b-form-select>
                      </b-form-group>
                    </div>
                    <div class="w-20 ml-2">
                      <b-form-group class="form-group">
                        <!-- コントロールユニット情報 検索 -->
                        <label v-if="reproRegion === 'Domestic'" class="label-sm">{{
                          $t("message.label_sold_vehicle_search_unit") }}</label>
                        <label v-else class="label-sm">{{ $t("message.label_sold_vehicle_search_cpu")
                          }}</label>
                        <b-form-select v-model="affectedUnit" size="sm" class="custom-select custom-select-sm">
                          <option v-for="item in getPullDownList('affected_unit')" :value="item">{{ item }}</option>
                        </b-form-select>
                      </b-form-group>
                    </div>
                  </div>
                </div>
                <!-- 北米・欧州一般 検索ボックス -->
                <div v-else class="col-12 text-left mt-3">
                  <div class="d-flex w-100">
                    <!-- 書換後部番 -->
                    <div class="w-20">
                      <b-form-group class="form-group">
                        <label class="label-sm">{{ $t("message.label_sold_vehicle_search_pack_number") }}</label>
                        <b-form-input type="text" v-model="packNumber" id="pack_number" size="sm">
                          {{ packNumber }}</b-form-input>
                      </b-form-group>
                    </div>
                    <div class="w-20 ml-2">
                      <!-- 車種 検索 -->
                      <b-form-group class="form-group">
                        <label class="label-sm">{{ $t("message.label_sold_vehicle_search_vehicle") }}</label>
                        <b-form-select v-model="vehicle" size="sm" class="custom-select custom-select-sm">
                          <option v-for="item in getPullDownList('vehicle')" :value="item">{{ item }}</option>
                        </b-form-select>
                      </b-form-group>
                    </div>
                    <div class="w-20 ml-2">
                      <!-- 年式 検索 -->
                      <b-form-group class="form-group">
                        <label class="label-sm">{{ $t("message.label_sold_vehicle_search_model_year") }}</label>
                        <b-form-select v-model="year" size="sm" class="custom-select custom-select-sm">
                          <option v-for="item in getPullDownList('year')" :value="item">{{ item }}</option>
                        </b-form-select>
                      </b-form-group>
                    </div>
                    <div class="w-20 ml-2">
                      <!-- 排ガス対応 検索 -->
                      <b-form-group class="form-group">
                        <label class="label-sm">{{ $t("message.label_sold_vehicle_search_emission_spec") }}</label>
                        <b-form-select v-model="specification" size="sm" class="custom-select custom-select-sm">
                          <option v-for="item in getPullDownList('specification')" :value="item">{{ item }}</option>
                        </b-form-select>
                      </b-form-group>
                    </div>
                    <!-- エンジン 検索 -->
                    <div class="w-20 ml-2">
                      <b-form-group class="form-group">
                        <label class="label-sm">{{ $t("message.label_sold_vehicle_search_engine") }}</label>
                        <b-form-select v-model="engine" size="sm" class="custom-select custom-select-sm">
                          <option v-for="item in getPullDownList('engine')" :value="item">{{ item }}</option>
                        </b-form-select>
                      </b-form-group>
                    </div>
                    <!-- 吸気方式 検索 -->
                    <div class="w-20 ml-2">
                      <b-form-group class="form-group">
                        <label class="label-sm">{{ $t("message.label_sold_vehicle_search_aspiration") }}</label>
                        <b-form-select v-model="aspiration" size="sm" class="custom-select custom-select-sm">
                          <option v-for="item in getPullDownList('aspiration')" :value="item">{{ item }}</option>
                        </b-form-select>
                      </b-form-group>
                    </div>
                    <div class="w-20 ml-2">
                      <!-- トランスミッション 検索 -->
                      <b-form-group class="form-group">
                        <label class="label-sm">{{ $t("message.label_sold_vehicle_search_t_m") }}</label>
                        <b-form-select v-model="transmission" size="sm" class="custom-select custom-select-sm">
                          <option v-for="item in getPullDownList('transmission')" :value="item">{{ item }}</option>
                        </b-form-select>
                      </b-form-group>
                    </div>
                    <div class="w-20 ml-2">
                      <b-form-group class="form-group">
                        <!-- CPU情報 検索 -->
                        <label class="label-sm">{{ $t("message.label_sold_vehicle_search_cpu")
                          }}</label>
                        <b-form-select v-model="affectedUnit" size="sm" class="custom-select custom-select-sm">
                          <option v-for="item in getPullDownList('affected_unit')" :value="item">{{ item }}</option>
                        </b-form-select>
                      </b-form-group>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <!-- Line 2 -->
            <div class="col-12">
              <div class="d-flex justify-content-between mb-3">
                <div class="invisible-placeholder"></div>
                <div>
                  <svg-button normal variant="primary" size="sm" iconKey="search" title="common_button_search"
                    @onclick="executeFilter()">
                  </svg-button>
                </div>
                <div>
                  <a class="clear-atag-style" href="javascript:void(0)" v-on:click="clear()">
                    {{ $t("message.common_button_clear") }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </template>
      </customCard>
      <div class="col-12">
        <cstm-table ref="custom_table" currentSortkey="create_time" useSort initSortDir="asc" rowSelect
          :columns="switchCountryColums()" :items="items" class="mt-2 ml-2" @rowClicked="clickRow"
          v-bind:maxTableHeight="tableHeight">
          <template v-slot:contentRightEnd>
            <cstm-pagination class="mb-1" ref="pagination" v-bind:pageSize='pageSize' v-bind:initPage=1
              v-bind:totalPageLength='itemLength' @selecedPage="selectedPAKPage" inRprService>
            </cstm-pagination>
            <div v-if="runPaginateData" class="d-flex align-items-center">
              <b-spinner small variant="primary"></b-spinner>
            </div>
          </template>
        </cstm-table>
      </div>
      <!-- PAK詳細ダイアログ表示 -->
      <div v-if="pakFileDetailDialog">
        <b-modal v-model="pakFileDetailDialog" header-bg-variant="primary" header-text-variant="light" no-stacking
          no-close-on-backdrop no-close-on-esc centered size="xl">
          <template v-slot:header>
            <div class="text-center w-100 ">{{ $t("message.header_pak_details") }}</div>
          </template>
          <template v-slot:default>
              <easy-table :columns="switchCountryColums()" :items="selectItems" class="mt-2 ml-2"
                type="simple"></easy-table>
              <!-- 仕向け地：日本 -->
              <div v-if="reproRegion === 'Domestic'">
                <div class="col-12 text-left mt-2">
                  <b-form-group class="form-group">
                    <label>{{ $t("message.label_pak_file_details_target_parts_number") }}</label>
                    <b-form-input type="text" v-model="selectItems[0].parts_number" size="sm" class="textarea-bg-white"
                      :disabled=true>
                      {{ selectItems[0].parts_number }}</b-form-input>
                  </b-form-group>
                </div>
                <div class="col-12 text-left mt-2">
                  <b-form-group class="form-group">
                    <label>{{ $t("message.label_pak_file_details_sum_value") }}</label>
                    <b-form-input type="text" v-model="selectItems[0].check_sum" size="sm" class="textarea-bg-white"
                      :disabled=true>
                      {{ selectItems[0].check_sum }}</b-form-input>
                  </b-form-group>
                </div>
                <div class="col-12 text-left mt-2">
                  <b-form-group class="form-group">
                    <label>{{ $t("message.label_pak_file_details_short_connector") }}</label>
                    <b-form-input type="text" v-model="selectItems[0].short_connector" size="sm"
                      class="textarea-bg-white" :disabled=true>
                      {{ selectItems[0].short_connector }}</b-form-input>
                  </b-form-group>
                </div>
                <div class="col-12 text-left mt-2">
                  <b-form-group class="form-group">
                    <label>{{ $t("message.label_pak_file_details_connection") }}</label>
                    <b-form-input type="text" v-model="selectItems[0].necessary_connector" size="sm"
                      class="textarea-bg-white" :disabled=true>
                      {{ selectItems[0].necessary_connector }}</b-form-input>
                  </b-form-group>
                </div>
                <div class="col-12 text-left mt-5">
                  <label>{{ $t("message.label_vehicle_system_translations") }}</label>
                  <b-form-select v-model="selectedLanguage" id="translation_language_domestic" size="sm" @change="updateLanguage"
                    class="w-25 ml-1 custom-select custom-select-sm">
                    <option v-for="lng in translationLangs" :value="lng.value">{{ lng.text }}</option>
                  </b-form-select>
                </div>
                <div class="col-12 text-left mt-4">
                  <div>
                    <label>{{ $t("message.header_vehicle_file_table_service_news") }}</label>
                  </div>
                  <div v-if="serviceNewsUrl" class="line-border">
                    <span v-for="(news, index) in serviceNewsList" :key="`news-${index}`" class="text-break service-news-inline">
                      <a class="text-break" :href="news.url" target="_blank" rel="noopener noreferrer">{{ news.name }}</a>
                      <span v-if="index !== serviceNewsList.length-1" class="text-break service-news-inline">{{ getServiceNewsSeparator }}</span>
                    </span>
                  </div>
                  <b-form-textarea v-else class="textarea-bg-white" :disabled=true v-model="combinedServiceNewsText"></b-form-textarea>
                </div>
                <div class="col-12 text-left mt-2">
                  <div>
                    <label>{{ $t("message.label_pak_file_details_comment") }}</label>
                  </div>
                  <b-form-textarea class="textarea-bg-white" :disabled=true v-model="problemFixedHistory"></b-form-textarea>
                </div>
                <div class="col-12 text-left mt-2">
                  <div>
                    <label>{{ $t("message.label_pak_file_details_caution") }}</label>
                  </div>
                  <b-form-textarea class="textarea-bg-white" :disabled=true v-model="attention"></b-form-textarea>
                </div>
              </div>
              <!-- 仕向け地：北米・欧州一般 -->
              <div v-else>
                <div class="col-12 text-left mt-2">
                  <b-form-group class="form-group">
                    <label>{{ $t("message.label_pak_file_details_target_parts_number") }}</label>
                    <b-form-input type="text" v-model="selectItems[0].parts_number" size="sm" class="textarea-bg-white"
                      :disabled=true>
                      {{ selectItems[0].parts_number }}</b-form-input>
                  </b-form-group>
                </div>
                <div class="col-12 text-left mt-2">
                  <b-form-group class="form-group">
                    <label>{{ $t("message.label_pak_file_details_appricable_cid") }}</label>
                    <b-form-input type="text" v-model="selectItems[0].applicable_cid" size="sm"
                      class="textarea-bg-white" :disabled=true>
                      {{ selectItems[0].applicable_cid }}</b-form-input>
                  </b-form-group>
                </div>
                <div class="col-12 text-left mt-2">
                  <b-form-group class="form-group">
                    <label>{{ $t("message.label_pak_file_details_new_cid") }}</label>
                    <b-form-input type="text" v-model="selectItems[0].cid" size="sm" class="textarea-bg-white"
                      :disabled=true>
                      {{ selectItems[0].cid }}</b-form-input>
                  </b-form-group>
                </div>
                <div class="col-12 text-left mt-2">
                  <b-form-group class="form-group">
                    <label>{{ $t("message.label_pak_file_details_sum_value") }}</label>
                    <b-form-input type="text" v-model="selectItems[0].check_sum" size="sm" class="textarea-bg-white"
                      :disabled=true>
                      {{ selectItems[0].check_sum }}</b-form-input>
                  </b-form-group>
                </div>
                <div class="col-12 text-left mt-2">
                  <b-form-group class="form-group">
                    <label>{{ $t("message.label_pak_file_details_connection") }}</label>
                    <b-form-input type="text" v-model="selectItems[0].necessary_connector" size="sm"
                      class="textarea-bg-white" :disabled=true>
                      {{ selectItems[0].necessary_connector }}</b-form-input>
                  </b-form-group>
                </div>
                <div class="col-12 text-left mt-5">
                  <label>{{ $t("message.label_vehicle_system_translations") }}</label>
                  <b-form-select v-model="selectedLanguage" id="translation_language_other" size="sm" @change="updateLanguage"
                    class="w-25 ml-1 custom-select custom-select-sm">
                    <option v-for="lng in translationLangs" :value="lng.value">{{ lng.text }}</option>
                  </b-form-select>
                </div>
                <div class="col-12 text-left mt-4">
                  <div>
                    <label>{{ $t("message.label_pak_file_details_service_bulletin") }}</label>
                  </div>
                  <div v-if="serviceNewsUrl" class="line-border">
                    <span v-for="(news, index) in serviceNewsList" :key="`news-${index}`" class="text-break service-news-inline">
                      <a class="text-break" :href="news.url" target="_blank" rel="noopener noreferrer">{{ news.name }}</a>
                      <span v-if="index !== serviceNewsList.length-1" class="text-break service-news-inline">{{ getServiceNewsSeparator }}</span>
                    </span>
                  </div>
                  <b-form-textarea v-else class="textarea-bg-white" :disabled=true v-model="combinedServiceNewsText"></b-form-textarea>
                </div>
                <div v-if="currentProvider === 'SUBSCRIBER'" class="mt-2 col-12">
                  <label>{{ $t("message.message_vehicle_under_system_service_news") }}</label>
                </div>
                <div class="col-12 text-left mt-2">
                  <b-form-group class="form-group">
                    <label>{{ $t("message.label_pak_file_details_update") }}</label>
                    <b-form-textarea v-model="problemFixedHistory" class="textarea-bg-white"
                      :disabled=true></b-form-textarea>
                  </b-form-group>
                </div>
                <div class="col-12 text-left mt-2">
                  <div>
                    <label>{{ $t("message.label_pak_file_details_note") }}</label>
                  </div>
                  <b-form-textarea class="textarea-bg-white" :disabled=true v-model="grade"></b-form-textarea>
                </div>
              </div>
              <!-- サービスニュース確認チェック -->
              <div class="text-center mt-4 mb-4 checkbox-size-lg">
                <!-- 日本 -->
                <div v-if="reproRegion === 'Domestic'">
                  <p class="mb-2">{{ $t("message.message_system_pak_repro_checkbox_domestic") }}</p>
                  <b-form-checkbox v-model="completionCheckServiceNews">
                    {{ $t("message.label_system_repro_checkbox_domestic") }}
                  </b-form-checkbox>
                </div>
                <!-- 北米・欧州一般 -->
                <div v-else>
                  <p class="mb-2">{{ $t("message.message_system_pak_repro_checkbox_other") }}</p>
                  <b-form-checkbox v-model="completionCheckServiceNews">
                    {{ $t("message.label_system_repro_checkbox_other") }}
                  </b-form-checkbox>
                </div>
              </div>
              <div class="col-12 text-left mt-4 d-flex align-items-center">
                <label class="mb-0 mr-4">{{ $t("message.label_pak_file_details_keyword") }}: {{ selectItems[0].keyword }}</label>
                <b-button size="sm" variant="primary" @click="copyPassword()">
                  {{ $t("message.button_copy_password") }}
                </b-button>
              </div>

          </template>
          <template v-slot:footer>
            <div class="col-12 text-center">
              <b-button size="sm" variant="outline-primary" class="mr-2" @click="closeModal()" :disabled="processing">
                {{ $t("message.common_button_cancel") }}
              </b-button>
              <b-button size="sm" variant="primary" @click="executeFw2Repro()" :disabled="processing || !completionCheckServiceNews">
                {{ $t("message.button_launch_fw") }}
              </b-button>

            </div>
          </template>
        </b-modal>
      </div>
    </div>
    <processing-view :processing="processing"></processing-view>
  </div>
</div>